import { AddressJSON } from "_shared/addresses/address-schema";
import MarketplaceResponseAPIResponse from "marketplace/_api/response-contracts/marketplace-response-api-response";
import Individual from "marketplace/individuals/individual";

export default class MarketplaceIndividualInfoAPIResponse extends MarketplaceResponseAPIResponse {
  public legalEntityId?: string;
  public companyId?: string;
  public companyName?: string;
  public firstName?: string;
  public lastName?: string;
  public description?: string;
  public location?: AddressJSON;
  public phoneNumber?: string;
  public school?: string;
  public degree?: string;
  public avatarId?: string;
  public email?: string;
  public resume?: string;
  public professionalRegistration?: string;
  public technicalBackground?: string;
  public numberOfApplicationsDraftedProsecuted?: number;
  public numberOfAllowedApplications?: number;
  public barAdmissionYear?: number;
  public isOnCall?: boolean;
  public insuredAmount?: number;
  public billingRate?: string;
  public billingUnit?: string;
  public potentialDiversityCandidate?: boolean;
  public collaborates?: boolean;
  public additionalInfo?: string;
  public links?: string[];
  public professionalPublications?: string[];
  public sampleApplications?: string[];
  public fluentLanguages?: string[];
  public technicalLanguages?: string[];
  public regionsRegistered?: string[];
  public regionsLicensed?: string[];
  public categories?: string[];
  public userId?: string;
  public hasEntitySigningAuthority?: boolean;

  public deserialize(): Individual {
    const { id, firstName, lastName, userId, legalEntityId, isVisible, email } = this;
    if (!id) throw new Error("Individual ID is required, was not returned by the API");
    if (!userId) throw new Error("User ID is required, was not returned by the API");
    if (!legalEntityId) throw new Error("Legal Entity ID is required, was not returned by the API");
    if (!firstName) throw new Error("firstName is required, was not returned by the API");
    if (!lastName) throw new Error("lastName is required, was not returned by the API");

    const individual = Individual.fromJSON({
      ...this,
      id,
      email,
      userId,
      firstName,
      lastName,
      legalEntityId,
      isVisible: isVisible ?? false,
      hasEntitySigningAuthority: this.hasEntitySigningAuthority ?? false,
      insured: {
        insuredAmount: this.insuredAmount ?? 0,
        currency: "usd",
      },
      billingRate: {
        billingRate: this.billingRate ?? "0",
        billingUnit: this.billingUnit ?? "hourly",
      },
      company: {
        id: this.companyId ?? "",
        legalEntityId: this.legalEntityId ?? "",
        name: this.companyName ?? "",
        categories: this.categories ?? [],
      },
      profile: {
        ...this,
        firstName,
        lastName,
        email,
        avatarId: this.avatarId,
        resume: this.resume,
        insuredAmount: this.insuredAmount,
        location: this.location?.address1
          ? {
              address1: this.location?.address1,
              address2: this.location?.address2,
              city: this.location?.city,
              state: this.location?.state,
              postalCode: this.location?.postalCode,
              country: this.location?.country,
              coordinates: this.location?.coordinates
                ? {
                    latitude: this.location?.coordinates?.latitude[0].toString() || "",
                    longitude: this.location?.coordinates?.longitude[0].toString() || "",
                  }
                : undefined,
            }
          : undefined,
      },
    });
    if (!individual) throw new Error("Failed to deserialize Individual");
    return individual;
  }
}
